import React from 'react';
import './Map.css';

function Map() {
    return (
        <div className='map'>
            <iframe
                title='Google Maps'
                src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2499.493209349802!2d0.791742176548488!3d51.209989371747234!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47ded7a830c5bfad%3A0x74ffc75e5599e3dc!2sSharen%20Cain%20FCCA!5e0!3m2!1sen!2suk!4v1725294176894!5m2!1sen!2suk'
                style={{border: 0}}
                height='250px'
                width='350px'
                allowFullScreen=''
                loading='eager'
                referrerPolicy='no-referrer-when-downgrade'>
            </iframe>
        </div>
    )
}

export default Map;